import { Check, X } from "lucide-react";

const traditional = [
  "Fuera del horario laboral",
  "Reactivo",
  "Genérico",
  "Encuestas esporádicas",
  "Sin intervención inmediata",
];
const hummany = [
  "Durante la jornada laboral",
  "Preventivo",
  "Personalizado",
  "Intervención en tiempo real",
  "Datos emocionales anónimos",
];

export function Differentiation() {
  return (
    <section className="relative bg-surface py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            El problema no es que no existan soluciones. <br className="hidden sm:block" />
            <span className="text-gradient-brand">Es que llegan tarde.</span>
          </h2>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-2">
          <div className="rounded-3xl border border-border bg-card p-8">
            <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">Antes</p>
            <h3 className="mt-2 text-xl font-semibold text-foreground">Bienestar corporativo tradicional</h3>
            <ul className="mt-6 space-y-3">
              {traditional.map((t) => (
                <li key={t} className="flex items-start gap-3 text-foreground/70">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-muted">
                    <X className="h-3 w-3 text-muted-foreground" />
                  </span>
                  <span className="text-sm">{t}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative overflow-hidden rounded-3xl border border-primary/20 bg-card p-8 shadow-soft">
            <div className="blur-blob -right-16 -top-16 h-56 w-56 bg-primary/30" />
            <div className="blur-blob -left-16 -bottom-16 h-56 w-56 bg-accent/25" />
            <div className="relative">
              <p className="text-xs font-medium uppercase tracking-wider text-primary">Hummany</p>
              <h3 className="mt-2 text-xl font-semibold text-foreground">Acompañamiento en tiempo real</h3>
              <ul className="mt-6 space-y-3">
                {hummany.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-foreground">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full gradient-brand">
                      <Check className="h-3 w-3 text-white" />
                    </span>
                    <span className="text-sm font-medium">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-3xl rounded-3xl border border-border bg-card p-10 text-center shadow-soft">
          <p className="text-xl font-medium text-foreground sm:text-2xl">
            No somos una app más de bienestar.
          </p>
          <p className="mt-2 text-xl font-medium text-gradient-brand sm:text-2xl">
            Somos una herramienta diaria de acompañamiento emocional.
          </p>
        </div>
      </div>
    </section>
  );
}
